module.exports = __webpack_public_path__ + "img/MUFG.9a72e252.png";